import { BaseAPI } from './base';
import { Account } from '../../types/entity/account';

/**
 * 账户API服务类
 * 继承BaseAPI，提供账户相关的CRUD操作
 */
export class AccountAPI extends BaseAPI<Account> {
  constructor() {
    super('/accounts');
  }
}

// 创建账户API实例
export const accountApi = new AccountAPI();

export default accountApi;